import { render, staticRenderFns } from "./msw-checkout.vue?vue&type=template&id=024fa1d6&scoped=true&"
import script from "./msw-checkout.vue?vue&type=script&lang=tsx&"
export * from "./msw-checkout.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-checkout.vue?vue&type=style&index=0&id=024fa1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024fa1d6",
  null
  
)

export default component.exports